import { ItemProps, VisibleItem } from '@hydra/types/navigation';

export function getListItemsObject (
  active: string,
  activeCategory: string | undefined,
  locale: string,
  url: string,
  visibleItems: VisibleItem[]
): Array<ItemProps> {
  const urlEncoded = encodeURIComponent(url);

  const dashboardListItem = {
    id: 'dashboard',
    label: 'project_home',
    href: `/${locale}/dashboard/${urlEncoded}`,
    active: (active === 'dashboard'),
    icon: 'home-2',
    className: 'nr-project-sidenav-dashboard'
  };

  const pagesListItem = {
    id: 'pages',
    label: 'review_a_page',
    href: `/${locale}/pages/${urlEncoded}`,
    active: (active === 'pages'),
    icon: 'book',
    className: 'nr-project-sidenav-pagereviews'
  };

  const marketingListItem = {
    id: 'marketing-checklist',
    label: 'todo_headtitle',
    href: `/${locale}/marketing-checklist/${urlEncoded}`,
    active: (active === 'marketing-checklist'),
    icon: 'report',
    className: 'nr-project-sidenav-marketingchecklist'
  };

  const assistantListItem = {
    id: 'assistant',
    label: 'assistant_tab_label',
    href: `/${locale}/assistant/${urlEncoded}`,
    active: (active === 'assistant'),
    icon: 'out',
    className: 'nr-project-sidenav-assistant'
  };

  const performanceListItem = {
    id: 'performance',
    label: 'core_web_vitals_label',
    href: `/${locale}/performance/${urlEncoded}`,
    active: (active === 'performance'),
    icon: 'performance',
    className: 'nr-project-sidenav-performance'
  };

  const trafficListItem = {
    id: 'traffic',
    label: 'traffic_label',
    href: `/${locale}/traffic/${urlEncoded}`,
    active: (active === 'traffic'),
    icon: 'node-graph',
    className: 'nr-project-sidenav-traffic',
    hasNewBadge: true
  };

  const serpListItem = {
    id: 'serp',
    label: 'serp',
    href: `/${locale}/serp/${urlEncoded}`,
    active: (active === 'serp'),
    icon: 'hashtag-2',
    className: 'nr-project-sidenav-keywordtool'
  };

  const crawlerListItem = {
    id: 'crawler',
    label: 'crawler',
    href: `/${locale}/crawler/${urlEncoded}`,
    icon: 'crawler',
    active: (active === 'crawler'),
    subitems: [
      {
        id: 'crawler_onpage',
        label: 'crawler_on_page',
        href: `/${locale}/crawler/${urlEncoded}/on-page/title-issues`,
        active: (activeCategory === 'on-page')
      },
      {
        id: 'crawler_http_status',
        label: 'crawler_http_status',
        href: `/${locale}/crawler/${urlEncoded}/http-status/5xx-errors`,
        active: (activeCategory === 'http-status')
      },
      {
        id: 'crawler_indexing',
        label: 'crawler_indexing',
        href: `/${locale}/crawler/${urlEncoded}/indexing/non-indexable-pages`,
        active: (activeCategory === 'indexing')
      },
      {
        id: 'crawler_canonical',
        label: 'crawler_canonical',
        href: `/${locale}/crawler/${urlEncoded}/canonical/canonical-issues`,
        active: (activeCategory === 'canonical')
      },
      {
        id: 'clarler_ecommerce',
        label: 'crawler_ecommerce',
        href: `/${locale}/crawler/${urlEncoded}/ecommerce/products`,
        active: (activeCategory === 'ecommerce')
      }
    ],
    className: 'nr-project-sidenav-sitecrawl'
  };

  const settingsListItem = {
    id: 'settings',
    label: 'pj_settings',
    href: `/${locale}/settings/${urlEncoded}`,
    active: (active === 'settings'),
    icon: 'gear',
    className: 'nr-project-sidenav-settings'
  };

  const list = [
    dashboardListItem,
    pagesListItem,
    marketingListItem,
    performanceListItem,
    trafficListItem,
    serpListItem,
    crawlerListItem,
    assistantListItem,
    settingsListItem
  ];

  return list.filter(item => visibleItems.includes(item.id as VisibleItem));
}
